import { performApiRequest } from "../../lib/api";

export interface TournamentRecord {
  id: string;
  venue_id: string;
  name: string;
  game: string;
  description: string | null;
  rules: string | null;
  registration_instructions: string | null;
  contact_phone: string | null;
  starts_at: string;
  ends_at: string;
  status: "draft" | "published" | "cancelled";
  venue_timezone: string;
  venue_name: string;
  updated_at: string;
  /** gaamed checks each tournament before players see it; null for drafts. */
  review_status?: "pending" | "approved" | "rejected" | null;
  review_note?: string | null;
  approved_at?: string | null;
}
export type TournamentInput = Pick<TournamentRecord, "name" | "game" | "description" | "rules" | "registration_instructions" | "contact_phone" | "starts_at" | "ends_at" | "status">;
function path(venueId: string) { return `/api/v1/provider/venues/${encodeURIComponent(venueId)}/tournaments`; }

export function listVenueTournaments(venueId: string, signal?: AbortSignal, offset = 0) {
  return performApiRequest<{ tournaments: TournamentRecord[]; total: number }>(`${path(venueId)}?limit=30&offset=${offset}`, { signal, disableOfflineFallback: true });
}
export function createTournament(venueId: string, input: TournamentInput, requestId: string) {
  return performApiRequest<TournamentRecord>(path(venueId), { method: "POST", body: { ...input, client_request_id: requestId } });
}
export function updateTournament(venueId: string, id: string, input: Partial<TournamentInput> & { expected_updated_at?: string }) {
  return performApiRequest<TournamentRecord>(`${path(venueId)}/${encodeURIComponent(id)}`, { method: "PATCH", body: input });
}
